if (!customElements.get('quantity-discount-picker')) {
    class QuantityDiscountPicker extends HTMLElement{
        constructor() {
            super();
            this.buttons = this.querySelectorAll(".quantity-button");
            this.quantitySelector = document.querySelector("product-info .price-per-item__container .quantity__input");
        }

        connectedCallback() {
            if(this.buttons) {
                this.buttons.forEach((button) => {
                    button.addEventListener("click", () => {
                        this.setQuantity(button);
                        this.setActive(button);
                    });
                });
            }

            if (this.quantitySelector) {
                this.quantitySelector.addEventListener("change", (event) => {
                    const quantity = Number(event.target.value);
                    if (!quantity || !this.buttons?.length) return;

                    const firstButton = this.buttons[0];
                    const exactMatchButton = Array.from(this.buttons).find((button) => {
                    return (
                        button.classList.contains("must-fit-quantity") &&
                        Number(button.dataset.quantity) === quantity
                    );
                    });

                    if (exactMatchButton) {
                    this.setActive(exactMatchButton);
                    return;
                    }

                    this.setActive(firstButton);
                });
            }

            this.onCartChanged = (event) => {
                this.resetToFirstButton();
            };
            document.addEventListener("cart:changed", this.onCartChanged);
        }

        disconnectedCallback() {
            if (this.onCartChanged) {
                document.removeEventListener("cart:changed", this.onCartChanged);
            }
        }

        resetToFirstButton() {
            if (!this.buttons?.length || !this.quantitySelector) return;

            const firstButton = this.buttons[0];
            const firstQuantity = Number(firstButton.dataset.quantity) || 1;

            this.quantitySelector.value = firstQuantity;
            this.quantitySelector.dispatchEvent(new Event("change", { bubbles: true }));
            this.setActive(firstButton);
        }

        setActive(button) {
            if(!this.buttons || !button) return;
            this.buttons.forEach((btn) => btn.classList.remove("active"));
            button.classList.add("active");
        }

        setQuantity(button) {
            if (!this.quantitySelector) return;

            const targetQuantity = Number(button.dataset.quantity);
            if (!targetQuantity) return;

            this.quantitySelector.value = targetQuantity;
            this.quantitySelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
    customElements.define('quantity-discount-picker', QuantityDiscountPicker);
};